export default __webpack_public_path__ + "static/media/spark.db9bd6f6.svg";